import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    connect: 'Connect',
    connectWallet: 'Connect wallet',
  },
};
